module.exports = "./img/06d768a02dad186e3ab14f2db7369913.png";